/**
 * Culture Supply - Price Range Slider v3
 * Labels fixas (absMin / absMax) nas extremidades
 * Thumbs brancos sobre barra laranja
 */

function buildSlider(facet) {
  if (facet.dataset.csSliderInit) return;
  facet.dataset.csSliderInit = '1';

  const minInput = facet.querySelector('input[name*="price"][name*="gte"], input[id*="GTE"]');
  const maxInput = facet.querySelector('input[name*="price"][name*="lte"], input[id*="LTE"]');

  if (!minInput || !maxInput) {
    delete facet.dataset.csSliderInit;
    return;
  }

  const absMin = parseFloat(minInput.getAttribute('data-min') || '0') || 0;
  const rawMax = maxInput.getAttribute('placeholder') || maxInput.getAttribute('data-max') || '1000';
  const absMax = parseFloat(rawMax.replace(/[^0-9.]/g, '')) || 1000;
  const curMin = parseFloat(minInput.value.replace(/[^0-9.]/g, '')) || absMin;
  const curMax = parseFloat(maxInput.value.replace(/[^0-9.]/g, '')) || absMax;

  const wrapper = document.createElement('div');
  wrapper.className = 'cs-price-slider-wrapper';
  wrapper.innerHTML = [
    '<div class="cs-price-slider-row">',
      '<span class="cs-price-label-min">' + Math.round(absMin) + '</span>',
      '<div class="cs-price-range-track">',
        '<div class="cs-price-range-track__bg"></div>',
        '<div class="cs-price-range-track__fill"></div>',
        '<input type="range" class="cs-price-range-input cs-price-range-input--min"',
          ' min="' + absMin + '" max="' + absMax + '" step="1" value="' + curMin + '">',
        '<input type="range" class="cs-price-range-input cs-price-range-input--max"',
          ' min="' + absMin + '" max="' + absMax + '" step="1" value="' + curMax + '">',
      '</div>',
      '<span class="cs-price-label-max">' + Math.round(absMax) + '</span>',
    '</div>'
  ].join('');

  const insertAfter = facet.querySelector('.price-facet__inputs-wrapper') ||
                      facet.querySelector('.facets__inputs-wrapper') ||
                      facet.firstElementChild;
  if (insertAfter) {
    insertAfter.insertAdjacentElement('afterend', wrapper);
  } else {
    facet.appendChild(wrapper);
  }

  const fill = wrapper.querySelector('.cs-price-range-track__fill');
  const sliderMin = wrapper.querySelector('.cs-price-range-input--min');
  const sliderMax = wrapper.querySelector('.cs-price-range-input--max');

  function updateUI() {
    const lo = parseFloat(sliderMin.value);
    const hi = parseFloat(sliderMax.value);
    const span = absMax - absMin || 1;
    fill.style.left  = ((lo - absMin) / span * 100) + '%';
    fill.style.right = ((absMax - hi)  / span * 100) + '%';
  }

  function syncHidden() {
    const lo = parseFloat(sliderMin.value);
    const hi = parseFloat(sliderMax.value);
    minInput.value = (lo === absMin) ? '' : String(lo);
    maxInput.value = (hi === absMax) ? '' : String(hi);
    updateUI();
  }

  sliderMin.addEventListener('input', function() {
    if (parseFloat(sliderMin.value) >= parseFloat(sliderMax.value)) {
      sliderMin.value = parseFloat(sliderMax.value) - 1;
    }
    syncHidden();
  });

  sliderMax.addEventListener('input', function() {
    if (parseFloat(sliderMax.value) <= parseFloat(sliderMin.value)) {
      sliderMax.value = parseFloat(sliderMin.value) + 1;
    }
    syncHidden();
  });

  function triggerChange() {
    maxInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  sliderMin.addEventListener('change', triggerChange);
  sliderMax.addEventListener('change', triggerChange);

  updateUI();
}

function scanAndBuild() {
  document.querySelectorAll('#filters-drawer price-facet-component').forEach(buildSlider);
}

var _csObserver = new MutationObserver(function(mutations) {
  var needsScan = false;
  mutations.forEach(function(m) {
    m.addedNodes.forEach(function(n) {
      if (n.nodeType !== 1) return;
      if (n.tagName === 'PRICE-FACET-COMPONENT' || (n.querySelector && n.querySelector('price-facet-component'))) {
        needsScan = true;
      }
    });
    if (m.type === 'attributes' && m.target.tagName === 'DIALOG') needsScan = true;
  });
  if (needsScan) setTimeout(scanAndBuild, 60);
});

document.addEventListener('DOMContentLoaded', function() {
  _csObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  scanAndBuild();
});
